module.exports = "https://s81616.cdn.ngenix.net/microcredits-frontend/_next/static/images/controlPhone-b91cb5e8acf532a625fc28559ca9a72d.png";